import constants from 'Constants';
import favoritesService from 'FavoritesService';
import global from 'Global';
import { initAsync as initLocaleSettingsAsync } from 'LocaleSettings';
import logonService from 'LogonService';
import navigationService from 'NavigationService';
import nativeBridge from 'NativeBridge';
import vueFactory from 'VueFactory';
import wtgMaterialUi from 'VuePlugins/WtgMaterialUi';
import $ from 'jQueryExtensions';

export default async function startupBootstrapperAsync() {
	try {
		await logonService.tryResumeAsync();
	} catch (e) {
		// ignore
	}
	await initLocaleSettingsAsync();

	if (global.materialDesign) {
		await Promise.all([
			setUpContentContainerAsync(),
			wtgMaterialUi.handleApplicationStartAsync(),
		]);
	}

	if (!nativeBridge.ensureSupportedVersion()) {
		return;
	}

	navigationService.start();
	favoritesService.attachEventHandlers();
}

async function setUpContentContainerAsync() {
	const contentContainer = document.getElementById('g-app');
	if (contentContainer) {
		const instance = await vueFactory.createVueInstanceAsync({
			contentContainer,
		});
		const $modalsContainer = $(instance.$el).find(
			constants.CssClasses.ModalsContainer.Selector,
		);
		$modalsContainer.data('is-initialized', true);
	}
}
